import useMediaQuery from "@mui/material/useMediaQuery";
import { theme } from "../styles/theme";

const useUI = () => {
    const isMobileMode = useMediaQuery(theme.breakpoints.down("md"));
    return { isMobileMode };
};

export default useUI;
